export default function useCurrentUser() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const roles = payload.roles || [];
        const isSuperAdmin = roles.includes('ROLE_SUPER_ADMIN');
        const isAdmin = roles.includes('ROLE_ADMIN') || isSuperAdmin;
        const isLog = roles.includes('ROLE_LOG') || isAdmin;
        const isSecretaire = roles.includes('ROLE_SECRETAIRE') || isAdmin;
        const isInfDiet = roles.includes('ROLE_INF_DIET') || isAdmin;

        return {
            email: payload.username,
            nom: payload.nom || payload.username,
            roles,
            isAdmin,
            isSuperAdmin,
            isLog,
            isSecretaire,
            isInfDiet,
            agenceId: payload.agence_id,
            agenceNom: payload.agence_nom,
        };
    } catch (err) {
        return null;
    }
}